(() => {
  if (window.mcpettyProductGalleryBound) return;
  window.mcpettyProductGalleryBound = true;
  document.addEventListener('load', (event) => {
    const image = event.target;
    if (!image.matches?.('img.mp-demo-product__image') || !image.naturalWidth || !image.naturalHeight) return;
    const frame = image.closest('.mp-demo-product__primary');
    if (!frame) return;
    frame.setAttribute('data-photo-frame', '');
    frame.style.setProperty('--mp-product-photo-ratio', String(image.naturalWidth / image.naturalHeight));
  }, true);
  document.addEventListener('click', (event) => {
    const target = event.target.closest?.('[data-mcpetty-gallery-thumbnail], [data-mcpetty-gallery-zoom]');
    if (!target) return;
    const gallery = target.closest('[data-mcpetty-native-gallery]');
    const frame = gallery?.querySelector('.mp-demo-product__primary');
    const image = frame?.querySelector('img.mp-demo-product__image');
    if (!image) return;
    if (target.matches('[data-mcpetty-gallery-zoom]')) {
      const dialog = gallery.querySelector('[data-mcpetty-gallery-dialog]');
      if (!dialog || dialog.open) return;
      const enlarged = image.cloneNode(true);
      enlarged.removeAttribute('id');
      enlarged.removeAttribute('class');
      enlarged.sizes = '90vw';
      dialog.querySelector('[data-mcpetty-gallery-zoom-image]').replaceChildren(enlarged);
      dialog.showModal();
      return;
    }
    if (!target.dataset.gallerySrc) return;
    image.srcset = target.dataset.gallerySrcset || '';
    image.src = target.dataset.gallerySrc;
    image.sizes = '(min-width: 1440px) 800px, (min-width: 761px) 56vw, calc(100vw - 24px)';
    image.alt = target.dataset.galleryAlt || '';
    frame.dataset.galleryMediaId = target.dataset.galleryMediaId || '';
    const photoRatio = Number(target.dataset.galleryAspectRatio);
    if (Number.isFinite(photoRatio) && photoRatio > 0) {
      frame.setAttribute('data-photo-frame', '');
      frame.style.setProperty('--mp-product-photo-ratio', String(photoRatio));
    }
    gallery.querySelectorAll('[data-mcpetty-gallery-thumbnail]').forEach(button => {
      button.setAttribute('aria-pressed', String(button === target));
    });
  });
  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (!dialog.matches?.('[data-mcpetty-gallery-dialog]')) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
})();
